module.exports = __webpack_public_path__ + "img/fondo-banner-principal.fb74ef67.svg";